import { render, staticRenderFns } from "./hqglLogisticsDispose.vue?vue&type=template&id=01704d71&scoped=true&"
import script from "./hqglLogisticsDispose.vue?vue&type=script&lang=js&"
export * from "./hqglLogisticsDispose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01704d71",
  null
  
)

export default component.exports